import CryptoJS from 'crypto-js';
import { encryptKey } from '../Constants';

export const validateField = (value: string, fieldName: string): string => {
  if (!value.trim()) {
    return `Das Feld "${fieldName}" darf nicht leer sein.`;
  }
  return "";
};

export const validateEmail = (email: string): string => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.trim()) {
    return "Das Feld 'E-Mail' darf nicht leer sein.";
  } else if (!regex.test(email)) {
    return "Ungültige E-Mail-Adresse.";
  }
  return "";
};

export const validateConfirmEmail = (email: string, confirmEmail: string): string => {
  if (!confirmEmail.trim()) {
    return "Das Feld 'E-Mail bestätigen' darf nicht leer sein.";
  } else if (confirmEmail.toLowerCase() !== email.toLowerCase()) {
    return "E-Mail-Adressen stimmen nicht überein.";
  }
  return "";
};

export const validatePassword = (password: string): string => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  if (!password.trim()) {
    return "Das Feld 'Passwort' darf nicht leer sein.";
  } else if (!regex.test(password)) {
    return "Passwort muss mindestens 8 Zeichen lang sein, Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.";
  }
  return "";
};

export const validateConfirmPassword = (password: string, confirmPassword: string): string => {
  if (!confirmPassword.trim()) {
    return "Das Feld 'Passwort bestätigen' darf nicht leer sein.";
  } else if (confirmPassword !== password) {
    return "Passwörter stimmen nicht überein.";
  }
  return "";
};

export const validatePhoneNumber = (phoneNumber: string): string => {
  const regex = /^\+?[0-9\s-]{6,}$/;
  if (!phoneNumber.trim()) {
    return "Das Feld 'Handynummer' darf nicht leer sein.";
  } else if (!regex.test(phoneNumber)) {
    return "Ungültige Telefonnummer.";
  }
  return "";
};

export const validateDate = (date: string): string => {
  if (!date.trim()) {
    return "Das Feld 'Datum' darf nicht leer sein.";
  }
  return "";
};

export const validateTextArea = (value: string, fieldName: string): string => {
  if (!value.trim()) {
    return `Das Feld "${fieldName}" darf nicht leer sein.`;
  }
  return "";
};

// Helper to make string URL-safe
function toBase64Url(str: string) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// Helper to convert back from base64url to normal base64
function fromBase64Url(str: string) {
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) str += '=';
  return str;
}

export const encryptQueryParam = (param: string) => {
  // Encrypt and encode to base64url. This is just to obfuscate the email in the URL, not real encryption.
  const encrypted = CryptoJS.AES.encrypt(param, encryptKey).toString();
  return toBase64Url(encrypted);
};

export const decryptQueryParam = (encryptedParam: string) => {
  // Decode from base64url to base64 before decrypting. This is obfuscation to hide the email from the url, not real encryption.
  const base64 = fromBase64Url(encryptedParam);
  const bytes = CryptoJS.AES.decrypt(base64, encryptKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const handleFormSubmit = async (
  e: React.FormEvent<HTMLFormElement>,
  validateForm: () => boolean,
  getFormData: (form: HTMLFormElement) => Record<string, any>,
  transformPayload: (data: Record<string, any>, tokenID: string, confirmedEmail: string, processID: number) => Record<string, any>,
  sendToAzureFunction: (data: Record<string, any>) => Promise<any>,
  setIsSubmitted: (value: boolean) => void,
  onSubmitCallback: (status: string) => void, // Callback to send status back to parent
  tokenID: string,
  confirmedEmail: string,
  processID: number
) => {
  e.preventDefault(); // Prevent default form submission behavior
  setIsSubmitted(true); // Indicate that the form has been submitted

  // Validate the form
  const isValid = validateForm();
  if (!isValid) {
    console.log("Form has errors. Please fix them.");
    return; // Stop further execution if the form is invalid
  }

  // If the form is valid, proceed with submission
  const form = e.currentTarget;
  const formData = getFormData(form);

  // Transform the payload using the mapping
  const transformedData = transformPayload(formData, tokenID, confirmedEmail, processID);
  console.log("Original Data:", formData);

  console.log("Transformed Data:", transformedData);

  try {
    const response = await sendToAzureFunction(transformedData);
    console.log("Form submitted successfully!", response);
    onSubmitCallback(`Ihr Auftrag wird jetzt bearbeitet.<br><br>Bei Rückfragen nennen Sie unserem Mitarbeiter bitte den untenstehenden Code und die PIN, die Sie im vorherigen Schritt erstellt haben.<br><br>Bitte geben Sie die PIN ausschließlich nur an unsere Mitarbeiter weiter.<br><br><strong style="font-size: 20px;">${tokenID}</strong>`);
  } catch (error) {
    console.error("Error submitting form:", error);
    onSubmitCallback("Fehler beim Senden des Formulars. Bitte versuchen Sie es später erneut"); // Send error status to parent
  }
};